import { SpacingType } from '@zoomit/primitives';
import { Typography } from '@zoomit/zoomit-ds';

type Props = {
  price: string;
} & React.ComponentProps<typeof Typography>;

const Price = (props: Props) => {
  const { price, spacing, className, ...rest } = props;

  return (
    <Typography
      variant="subhead"
      spacing={spacing}
      tag="p"
      style={{ display: 'inline-block', height: '1.84rem' }}
      suppressHydrationWarning
      className={className}
      {...rest}
    >
      {price !== '0' && (
        <>
          از
          <Typography spacing={{ mx: 'x' }} className="fa" tag="span" variant="h5" aria-label="قیمت">
            {price}
          </Typography>
          تومان
        </>
      )}
    </Typography>
  );
};

export default Price;
